import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Box,
    Typography
} from '@mui/material';

const TacticsModal = ({ open, onClose, onSave, match, teamPlayers, tactics, initialSelection }) => {
    const [captain, setCaptain] = useState('');
    const [tactic, setTactic] = useState('');

    useEffect(() => {
        if (initialSelection) {
            setCaptain(initialSelection.captain || '');
            setTactic(initialSelection.tactic || '');
        } else {
            setCaptain('');
            setTactic('');
        }
    }, [initialSelection, open]); // Reset state when modal opens

    const handleSave = () => {
        onSave({ captain, tactic });
    };

    if (!match) return null;

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
            <DialogTitle>
                Keuzes voor wedstrijd
                <Typography variant="body2" color="text.secondary">
                    {match.home} vs {match.away}
                </Typography>
            </DialogTitle>
            <DialogContent>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, pt: 1 }}>
                    <FormControl fullWidth>
                        <InputLabel id="captain-select-label">Aanvoerder (1.5x punten)</InputLabel>
                        <Select
                            labelId="captain-select-label"
                            value={captain}
                            label="Aanvoerder (1.5x punten)"
                            onChange={(e) => setCaptain(e.target.value)}
                        >
                            {teamPlayers.map(p => <MenuItem key={p.id} value={p.id}>{p.name}</MenuItem>)}
                        </Select>
                    </FormControl>
                    <FormControl fullWidth>
                        <InputLabel id="tactic-select-label">Tactiek</InputLabel>
                        <Select
                            labelId="tactic-select-label"
                            value={tactic}
                            label="Tactiek"
                            onChange={(e) => setTactic(e.target.value)}
                        >
                            {tactics.map(t => <MenuItem key={t.id} value={t.id}>{t.name}</MenuItem>)}
                        </Select>
                    </FormControl>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Annuleren</Button>
                <Button onClick={handleSave} variant="contained">Opslaan</Button>
            </DialogActions>
        </Dialog>
    );
};

export default TacticsModal;

